import { HeaderWrapper } from 'layouts';
import type { Event } from 'models';
import { HeaderAsset, HeaderContent, ScrollToTop } from 'ui';
import { EventCanceledTitle, InviteesCount } from '../../components';
import { useGetEventTagsProperties, useGetEventTimeInfo } from '../../hooks';
import { EventRsvpStatus } from '../event-rsvp-status';
import { useGetEventCoverPhoto } from '../hooks';

type P = {
  event: Event;
};

const EventHeaderCanceled = ({ event }: P) => {
  const { endTime, goingCount, name, notGoingCount, participants, startTime, status, type } = event;
  const tags = useGetEventTagsProperties({ endTime, eventType: type, startTime, status });
  const coverPhotoSource = useGetEventCoverPhoto(event);
  const getTimeInfo = useGetEventTimeInfo();

  return (
    <>
      <ScrollToTop />
      <HeaderWrapper
        left={<HeaderAsset image={{ alt: 'Event cover photo', src: coverPhotoSource }} />}
        right={
          <HeaderContent
            extra={<EventRsvpStatus event={event} />}
            isStrikeThrough
            tags={tags}
            timeInfo={getTimeInfo({ event })}
            title={<EventCanceledTitle title={{ children: name }} />}
          >
            <InviteesCount
              eventType={type}
              inviteesCount={{
                going: goingCount,
                notGoing: notGoingCount,
                pending: participants.length - (goingCount + notGoingCount),
              }}
            />
          </HeaderContent>
        }
      />
    </>
  );
};

export default EventHeaderCanceled;
